import Vue from "vue/dist/vue.esm.js";

const jsSort = document.querySelector("#js-sort");
if (jsSort) {
  const vueApp = new Vue({
    el: "#js-sort",
    data: {
      resultData: [],
      GeneralTimeFlag: true,
      PointFlag: true,
      ClimberFlag: true,
      StageTimeFlag: true,
      YoungRiderFlag: true,
      BestJapaneseFlag: true,
      activeButton: null,
    },
    methods: {
      convertToSortableTime(time) {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        return new Date(0, 0, 0, hours, minutes, seconds);
      },
      toggleActiveButton(buttonId) {
        if (this.activeButton) {
          document
            .querySelector(`#${this.activeButton}`)
            .classList.remove("is-active");
        }
        this.activeButton = buttonId;
        document.querySelector(`#${buttonId}`).classList.add("is-active");
      },
      // 列ごとにアクティブなクラスを設定
  setActiveColumn(columnId) {
    const columns = [
      "js-generalTime_table",
      "js-climber_table",
      "js-point_table",
      "js-youngRider_table",
      "js-stageTime_table",
      "js-japanese_table",
    ];

    // すべての列から is-active クラスを削除
    columns.forEach(colId => {
      const column = document.getElementById(colId);
      if (column) {
        column.classList.remove("is-active");
      }
    });

    // 指定された列に is-active クラスを追加
    const activeColumn = document.getElementById(columnId);
    if (activeColumn) {
      activeColumn.classList.add("is-active");
    }
  },
      sortGeneralTime() {
        // 総合時間賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.GeneralTime === "DNF") return 1; // "DNF" は最後にソート
          if (b.GeneralTime === "DNF") return -1;
          if (a.GeneralTime === "") return 1; // 空白の場合は最後にソート
          if (b.GeneralTime === "") return -1;
          if (a.GeneralTime === "\r") {
            return 1;
          }
          if (b.GeneralTime === "\r") {
            return -1;
          }
          const timeA = this.convertToSortableTime(a.GeneralTime);
          const timeB = this.convertToSortableTime(b.GeneralTime);
          return timeA - timeB;
        });

        this.GeneralTimeFlag = !this.GeneralTimeFlag;
      },
      sortPoint() {
        // ポイント賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.Point === "") return 1; // 空白の場合は最後にソート
          if (b.Point === "") return -1;
          if (a.Point === "\r") {
            return 1;
          }
          if (b.Point === "\r") {
            return -1;
          }
          return b.Point - a.Point; // 降順に変更
        });

        this.PointFlag = !this.PointFlag;
      },
      sortClimber() {
        // 山岳賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.Climber === "") return 1; // 空白の場合は最後にソート
          if (b.Climber === "") return -1;
          if (a.Climber === "\r") {
            return 1;
          }
          if (b.Climber === "\r") {
            return -1;
          }
          return b.Climber - a.Climber; // 降順に変更
        });

        this.ClimberFlag = !this.ClimberFlag;
      },
      sortStageTime() {
        // 区間賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.StageTime === "DNF") return 1; // "DNF" は最後にソート
          if (b.StageTime === "DNF") return -1;
          if (a.StageTime === "") {
            return 1;
          }
          if (b.StageTime === "") {
            return -1;
          }
          if (a.StageTime === "\r") {
            return 1;
          }
          if (b.StageTime === "\r") {
            return -1;
          }
          const timeA = this.convertToSortableTime(a.StageTime);
          const timeB = this.convertToSortableTime(b.StageTime);
          return timeA - timeB;
        });

        this.StageTimeFlag = !this.StageTimeFlag;
      },
      sortYoungRider() {
        // 新人賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.YoungRider === "") {
            return 1;
          }
          if (b.YoungRider === "") {
            return -1;
          }
          if (a.YoungRider === "\r") {
            return 1;
          }
          if (b.YoungRider === "\r") {
            return -1;
          }
          // 数字を昇順にソート
          return a.YoungRider - b.YoungRider;
        });

        this.YoungRiderFlag = !this.YoungRiderFlag;
      },     
      sortBestJapanese() {
        // 最高日本人賞
        this.resultData = this.resultData.sort((a, b) => {
          if (a.BestJapanese === "\r") {
            return 1;
          }
          if (b.BestJapanese === "\r") {
            return -1;
          }
          if (a.BestJapanese === "") {
            return 1;
          }
          if (b.BestJapanese === "") {
            return -1;
          }
          // 数字を昇順にソート
          return a.BestJapanese - b.BestJapanese;
        });

        this.BestJapaneseFlag = !this.BestJapaneseFlag;
      },
    },

    async mounted() {
      let csvPath = document.querySelector(".l-contents");
      console.log(csvPath.dataset.urlPath);
      // 1. CSVファイルをアップロードまたはファイルパスを指定
      // const csvFilePath = "/assets/csv/fukuoka/Stage1.csv";
      const csvFilePath = csvPath.dataset.urlPath;

      // 2. CSVを読み込むための関数を定義
      const convertCSVtoJSON = (csv) => {
        const lines = csv.split("\n");
        const result = [];
        const headers = lines[0].replace("\r", "").split(",");
        console.log(headers);

        for (let i = 1; i < lines.length; i++) {
          const obj = {};
          const currentLine = lines[i].split(",");

          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentLine[j];
          }

          result.push(obj);
        }

        return result;
      };

      // 3. CSVファイルを読み込み、JSONに変換する
      await fetch(csvFilePath)
        .then((response) => response.text())
        .then((csvData) => {
          const jsonData = convertCSVtoJSON(csvData);
          this.resultData = jsonData;

          // ここでjsonDataを必要に応じて利用できます
        })
        .catch((error) =>
          console.error("CSVファイルの読み込みに失敗しました:", error)
        );

      console.log(this.resultData.map((a) => a));
    },
  });

  // ボタンのクリックイベントを設定
  const generalTimeButton = document.querySelector("#sortGeneralTime");
  const pointButton = document.querySelector("#sortPoint");
  const climberButton = document.querySelector("#sortClimber");
  const stageTimeButton = document.querySelector("#sortStageTime");
  const bestJapaneseButton = document.querySelector("#sortBestJapanese");
  const youngRiderButton = document.querySelector("#sortYoungRider");

  if (generalTimeButton) {
    generalTimeButton.addEventListener("click", () => {
      vueApp.sortGeneralTime();
      vueApp.toggleActiveButton("sortGeneralTime");
      vueApp.setActiveColumn("js-generalTime_table");
    });
  }

  if (pointButton) {
    pointButton.addEventListener("click", () => {
      vueApp.sortPoint();
      vueApp.toggleActiveButton("sortPoint");
      vueApp.setActiveColumn("js-point_table");
    });
  }

  if (climberButton) {
    climberButton.addEventListener("click", () => {
      vueApp.sortClimber();
      vueApp.toggleActiveButton("sortClimber");
      vueApp.setActiveColumn("js-climber_table");
    });
  }

  if (stageTimeButton) {
    stageTimeButton.addEventListener("click", () => {
      vueApp.sortStageTime();
      vueApp.toggleActiveButton("sortStageTime");
      vueApp.setActiveColumn("js-stageTime_table");
    });
  }

  if (bestJapaneseButton) {
    bestJapaneseButton.addEventListener("click", () => {
      vueApp.sortBestJapanese();
      vueApp.toggleActiveButton("sortBestJapanese");
      vueApp.setActiveColumn("js-japanese_table");
    });
  }

  if (youngRiderButton) {
    youngRiderButton.addEventListener("click", () => {
      vueApp.sortYoungRider();
      vueApp.toggleActiveButton("sortYoungRider");
      vueApp.setActiveColumn("js-youngRider_table");
    });
  }
}

// #sortStageTimeをクリックしたらjs-stageTime_tableに.is-activeを付与
